<template>
    <div style="max-width: 820px; margin:auto" class="text-right">
        <b-button variant="danger" @click="generate('pdf')">
            <i class="fa fa-download" aria-hidden="true"></i>
            {{$t('button.pdf')}}
        </b-button>
        <b-button variant="primary" @click="generate('word')">
            <i class="fa fa-download" aria-hidden="true"></i>
            {{$t('button.word')}}
        </b-button>
    </div>
</template>

<script>
    export default {
        name: 'dowload-transcript',
        props: ['id', 'type', 'localGradeLabel', 'local_transcripts'],

        methods: {
            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {
                    type
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async generate(method) {
                let url = this.local_transcripts?'localTranscripts':'transcripts';
                let grade_label = this.localGradeLabel;
                let token = await this.createToken('transcript');
                if (token == '') return;

                window.open(`/${url}/${this.id}/${method}?m=${this.type}&token=${token}&grade_label=${grade_label}`, '_blank');
            }
        }
    }

</script>
